import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { get_sorted_current_workspace_users } from '@/utils/utils_workspace';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { WSTableUserCreditLimitsHeader } from './WSTableUserCreditLimitsHeader';
import { WSTableUserCreditLimitsRowCheckboxes } from './rows/WSTableUserCreditLimitsRowCheckboxes';
import { WSTableUserCreditLimitsRowCreditsUsed } from './rows/WSTableUserCreditLimitsRowCreditsUsed';
import { WSTableUserCreditLimitsRowInputs } from './rows/WSTableUserCreditLimitsRowInputs';
import { WSTableUserCreditLimitsRowResets } from './rows/WSTableUserCreditLimitsRowResets';

export function WSTableUserCreditLimits() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { all_workspaces_users_map } = use_slice_workspace(['all_workspaces_users_map']);

  const render_view = useCallback(() => {
    const users = get_sorted_current_workspace_users();

    if (users.length === 0) {
      return <TABLE__empty />;
    } else {
      return (
        <div className="flex flex-col justify-start items-center h-full w-full ">
          <WSTableUserCreditLimitsRowCheckboxes users={users} />
          <WSTableUserCreditLimitsRowInputs users={users} />
          <WSTableUserCreditLimitsRowCreditsUsed users={users} />
          <WSTableUserCreditLimitsRowResets users={users} />
        </div>
      );
    }
  }, [all_workspaces_users_map]);

  return (
    <div className="w-full h-full">
      <div className={`${md('h-full w-full overflow-auto', ' pt-2 ')} mt-3 flex flex-col justify-center items-start `}>
        <div className="text-xl">{t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_limit.title)}</div>
        <div className={`${md('px-2 justify-start gap-2', 'px-5 justify-start')} w-full min-h-[50px] flex flex-row items-center mt-2`}>
          <span className={`${md('min-w-[130px] text-[10px]', 'min-w-[220px]')} text-left flex items-center`}>
            <div className="w-[70px]"></div>
          </span>
          <WSTableUserCreditLimitsHeader />
        </div>

        <div className="w-full border-t border-component-item"></div>

        {render_view()}
      </div>
    </div>
  );
}
